import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const useTemplates = (alwaysRefresh, params) => {
    return Model({
        alwaysRefresh,
        stateKey: ['templates'],
        fetchData: () => API.get('/templates'),
        returnDataKey: 'templates',
        defaultLoadingError: 'Failed to load templates.',
        saveAdditionalData: (response) => {
            response.map((template) => {
                State.putIfNotExists(['templates', template.id], template);
                return template;
            });
        },
    });
}

const useTemplate = (templateId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        block: !templateId,
        stateKey: ['templates', templateId],
        fetchData: () => API.get(`/templates/${templateId}`),
        returnDataKey: 'template',
        defaultLoadingError: 'Failed to load template.',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/templates/${templateId}`, data),
                        'Template updated',
                        true,
                    );
                },
            }
        },
    });
}

const tagLengths = {
    // Business
    'business.facebook' : 31,
    'business.instagram' : 20,
    'business.name' : 20,
    'business.tagline' : 40,
    'business.phoneNumber' : 13,
    'business.trustPilot' : 28,
    'business.twitter' : 15,
    'business.website' : 36,
    'business.whatsApp' : 13,
    'business.mastodon' : 17,
    'business.threads' : 12,
    'business.youtube' : 15,
    'business.google' : 26,
    // Customer
    'customer.balance' : 5,
    'customer.balanceStatus' : 6,
    'customer.email' : 28,
    'customer.firstName' : 11,
    'customer.lastName' : 11,
    'customer.name' : 11,
    'customer.businessName' : 18,
    'customer.autoName' : 16,
    'customer.type' : 9,
    'customer.phoneNumber' : 13,
    'customer.address' : 100,
    'customer.addressFirstLine' : 20,
    'customer.addressTown' : 9,
    'customer.addressPostcode' : 8,
    'customer.addressCountry' : 5,
    'customer.addressStreetName' : 12,
    'customer.postcode' : 8,
    'customer.shortId' : 4,
    'customer.status' : 7,
    'customer.pin' : 6,
    // Invoice
    'invoice.total' : 8,
    'invoice.outstanding' : 8,
    'invoice.paid' : 8,
    'invoice.status' : 8,
    'invoice.dueDate' : 16,
    // Job
    'job.cost' : 8,
    'job.dueWeek' : 16,
    'job.frequency' : 11,
    'job.lastDone' : 16,
    'job.notes' : 63,
    'job.scheduled' : 16,
    'job.scheduledDate' : 16,
    'job.estimatedTime' : 6,
    'job.services' : 11,
    'job.shortId' : 4,
    'job.status' : 6,
    // Quote
    'quote.name' : 13,
    'quote.firstName' : 13,
    'quote.lastName' : 13,
    'quote.status' : 11,
    'quote.address' : 100,
    'quote.addressFirstLine' : 20,
    'quote.addressTown' : 9,
    'quote.addressPostcode' : 8,
    'quote.addressCountry' : 5,
    'quote.addressStreetName' : 12,
    // User
    'user.email' : 27,
    'user.name' : 14,
    'user.firstName' : 6,
    'user.lastName' : 7,
    // Link
    'link' : 140,
    'link.short' : 21,
}

export {
    useTemplates,
    useTemplate,
    tagLengths,
};
